import React from "react";

const ActionButtons = ({ showTable, setShowTable, schedule, downloadScheduleCSV, handleShare, copied }) => (
  <div className="bg-white dark:bg-neutral-800 rounded-2xl shadow-lg p-6">
    <div className="space-y-4">
      <button
        onClick={() => setShowTable(!showTable)}
        className="w-full px-6 py-2 bg-blue-600 text-white rounded-xl hover:bg-blue-700 transition flex items-center justify-center gap-2"
      >
        <span>📊</span>
        {showTable ? "Hide Schedule" : "View Schedule"}
      </button>

      <button
        onClick={() => downloadScheduleCSV(schedule)}
        className="w-full px-6 py-2 bg-green-600 text-white rounded-xl hover:bg-green-700 transition flex items-center justify-center gap-2"
      >
        <span>💾</span>
        Download CSV
      </button>

      <button
        onClick={handleShare}
        className="w-full px-6 py-2 bg-orange-600 text-white rounded-xl hover:bg-orange-700 transition flex items-center justify-center gap-2"
      >
        <span>{copied ? "✓" : "🔗"}</span>
        {copied ? "Copied!" : "Share"}
      </button>
    </div>
  </div>
);

export default ActionButtons;
